import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=404dc516&"
import script from "./createActivity.vue?vue&type=script&lang=js&"
export * from "./createActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports